<template>
  <div class="documents-page-wrapper">
    <div class="documents-scroll">
      <div class="documents-data">
        <div class="documents-heading">
          <span>
            {{ $t('message.documentsPage.heading.type') }}
          </span>
          <span>
            {{ $t('message.documentsPage.heading.dateStart') }}
          </span>
        </div>

        <div class="empty-list" v-if="!documentsList.length">
          {{ $t('message.documentsPage.noData') }}
        </div>

        <div class="documents-container" v-if="documentsList.length">
          <div class="document-item" v-for="(item, index) of documentsList" :key="index">
            <a :href="item.path" class="item-link" download>
              <img src="/custom/images/document.svg" alt="Document">
              <span class="item-desc">
                {{ $t(`message.documentsPage.active.${item.name}`) }}
              </span>
            </a>

            <span class="item-date">
              {{ item.date }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentsPending',
  data() {
    return {
      documentsList: [
        // {
        //   path: '/static/documents/pending/Договор_возмездного_оказания_услуг.pdf',
        //   name: 'service',
        //   date: '11.08.2026'
        // }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.documents-page-wrapper {
  @include base-page-wrapper;
  @include static-heading-container;

  min-height: auto;
}

.documents-scroll {
  width: 100%;
  overflow-x: auto;
}

.documents-data {
  width: 95%;
  min-width: 770px;
  max-width: 1730px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.documents-heading {
  @include document-heading;
}

.empty-list {
  width: 100%;
  padding-top: 10px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  justify-content: center;
}

.documents-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.document-item {
  @include document-item;
}

.item-link {
  all: unset;
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.item-desc {
  font-size: .895rem;
  color: #1a8d48;
  font-weight: 600;
}

.item-date {
  color: #01273b;
}
</style>